export const COIN_CAP = {
  API: {
    HOST: 'https://api.coincap.io/v2',
    PRICE_ENDPOINT: '/assets/',
    COIN_LIST_ENDPOINT: '/assets',
  },
}
